<script>
  import options from './ListPageList.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
  <article class="be-list-page-list be-color-theme--white-black" >

    <div class="be-list-page-list__wrapper">

      <FilterConcept :guid="guid" :filters="filters" :searchKey="type" />

      <ul class="be-list-page-list__list">
        <li v-for="item, index in list" :key="index">
          <ListItem :result="item" />
        </li>
      </ul>

      <div class="be-list-page-list__no-results" v-if="list.length === 0 && !loading">
        <p class="be-list-page-list__no-results-text">{{ labels.noResults }}</p>
      </div>

      <div class="be-list-page-list__loading" v-if="loading">
        <p class="be-list-page-list__loading-text">{{ labels.loading }}</p>
        <div class="be-list-page-list__loading-bobble">
          <div class="be-list-page-list__loading-bobble-outer">
            <div class="be-list-page-list__loading-bobble-inner"></div>
          </div>
        </div>
      </div>

      <PageControls 
        v-if="totalResultCount > 0"
        :label="labels.loadMoreText" 
        :buttonLabel="labels.loadMoreButton"
        :currentSize="currentResultCount"
        :totalSize="totalResultCount"
        :callback="loadMoreCallback"
      />
    </div>
  </article>
</template>
